/**
 * SetDocumentTitle Handler для HeaderPage
 * Встановлює заголовок документа (title в браузері)
 * 
 * @param params - параметри з props
 */
export const SetDocumentTitle = ({ props }: any) => {
    if (props?.title) {
        document.title = typeof props.title === 'string' ? props.title : ''
    }
}
